import React, { useEffect, useState } from 'react'
import { FONT } from 'theme/font'
import Flex from 'components/Flex'
import Button from 'components/Button'
import CheckIcon from 'components/icons/CheckIcon'
import Avatar from 'components/Avatar'
import { Divider } from 'antd'
import AlarmOn from 'components/icons/Alarm_On'
import LocationIcon from 'components/icons/LocationIcon'
import PaymentIcon from 'components/icons/PaymentIcon'
import ConstructionIcon from 'components/icons/ConstructionIcon'
import CustomTag from 'components/CustomTag'
import {
  VerticalDivider,
  StyledDrawer,
  FooterFlex,
  Name1,
  PopHeading,
  PopSubHeading,
  Address,
  NameAdd,
  SubtitleSmall,
  FlexWrap,
  InfoText,
  SkillList,
} from 'modules/Roles/Style/style'
import { useSelector } from 'react-redux'
import { formatNumber } from 'utils/formatNumber'
import { checkJobCategory } from '../../../utils/const'

const ConfirmDrawer = ({
  drawer,
  setDrawer,
  onApplyClick,
  dataSelected,
  getSingleRoleDetails,
  collegeTier,
}) => {
  const [tierCtc, setTierCtc] = useState()
  const [tierCtcMin, setTierCtcMin] = useState()
  const [isRange, setIsRange] = useState(false)
  useEffect(() => {
    if (dataSelected?.corporate?.id)
      getSingleRoleDetails(dataSelected?.corporate?.id, dataSelected?.id)
  }, [])

  useEffect(() => {
    dataSelected?.CTC?.map((salary, index) => {
      if (salary?.name === collegeTier) {
        if (salary?.isRange) {
          setIsRange(true)
          setTierCtc(salary?.max)
          setTierCtcMin(salary?.min)
        } else {
          setTierCtc(salary?.max)
        }
      }
    })
  }, [dataSelected])
  const singleRoleDetails = useSelector(
    state => state?.rolesListData?.singleRoleDetails
  )
  let mandatorySkillNames = singleRoleDetails.mandatorySkillNames ?? null
  const hasNonEmptySkillSet = mandatorySkillNames?.otherSkillsNames?.some(
    (skillSet) => skillSet?.skillNames?.length > 0
  );
  const CheckIcons = logo => {
    if (logo === null) {
      return (
        <Avatar
          background
          size={42}
          IconName={dataSelected?.corporate?.name[0]}
          font={18}
        />
      )
    } else {
      return (
        <Avatar
          size={42}
          src={dataSelected?.corporate?.logo}
          boxShadow={true}
          padding={'3px'}
        />
      )
    }
  }

  const content = () => {
    const checkCity = cityList => {
      if (cityList !== undefined) {
        if (cityList?.length > 1) {
          return (
            <div>
              {cityList[0]?.name}, + {cityList?.length - 1}
            </div>
          )
        } else if (cityList?.length === 1) {
          return cityList[0]?.name
        } else {
          return '-'
        }
      }
    }
    const checkRange = () => {
      if (isRange) {
        return `${formatNumber(tierCtcMin)} - ${formatNumber(tierCtc)}`
      } else {
        return formatNumber(tierCtc)
      }
    }

    const checkJobTypeLevel = (data, YOE) => {
      const transformedData = data?.map(item => {
        switch (item) {
          case 'ENTRY':
            return ' Entry Level'
          case 'INTERN':
            return ' Internship'
          case 'EXPERIENCED':
            return YOE?.length > 0
              ? ` ${YOE[0]} - ${YOE[1]} Yrs Experience `
              : ` 0 - 1 Yrs Experience `
          default:
            return item
        }
      })

      return transformedData?.toString()
    }

    return (
      <>
        <Flex centerVertically>
          {CheckIcons(dataSelected?.corporate?.logo)}
          <NameAdd column flexStart>
            <Address>{dataSelected?.corporate?.name}</Address>
            <Name1>{dataSelected?.tittle}</Name1>
          </NameAdd>
        </Flex>
        <br></br>
        <Flex centerVertically>
          <Avatar src={<AlarmOn />} padding={'5px'} />
          <Address>
            {dataSelected?.rolePublishedBy == 'INSTITUTE'
              ? checkJobCategory(dataSelected?.jobCategory)
              : checkJobTypeLevel(
                  dataSelected?.jobTypeLevels,
                  dataSelected?.yearOfExperience
                )}{' '}
            ({dataSelected?.jobType === 'FULL_TIME' ? 'Full Time' : 'Part Time'}
            )
          </Address>
          <VerticalDivider type="vertical" />
          <Avatar src={<LocationIcon />} padding={'5px'} />
          &nbsp;
          <Address>
            {singleRoleDetails?.isAnyWhere
              ? 'AnyWhere'
              : checkCity(singleRoleDetails?.cities)}
          </Address>
          <VerticalDivider type="vertical" />
          <Avatar src={<PaymentIcon />} padding={'5px'} />
          &nbsp;
          <Address>
            ₹{' '}
            {dataSelected?.CTCIsTierBased
              ? checkRange()
              : formatNumber(dataSelected.maxCompensation)}{' '}
            {dataSelected?.CTCPeriod == 'ANNUALLY'
              ? 'Per annum'
              : dataSelected?.CTCPeriod == 'MONTHLY'
              ? 'Per month'
              : dataSelected?.CTCPeriod == 'WEEKLY'
              ? 'Per week'
              : dataSelected?.CTCPeriod == 'DAILY'
              ? 'Per day'
              : dataSelected?.CTCPeriod == 'HOURLY'
              ? 'Per hour'
              : ''}
          </Address>
        </Flex>
        <Divider />
        <Flex>
          <Avatar size={20} src={<ConstructionIcon />} />
          &nbsp;&nbsp;
          <Name1>Eligibility Criteria </Name1>
        </Flex>
        <div>
          <PopHeading>Mandatory Skills</PopHeading>
          <SkillList>
            <SubtitleSmall
              fontsize={FONT.XS}
              padding="4px"
              fontweight={FONT.FW_600}
            >
              <li>Primary Mandatory Skills</li>
            </SubtitleSmall>
            <FlexWrap wrap gap="1px" padding="5px 0px 0px 0px">
              {mandatorySkillNames?.primarySkillNames?.skillNames?.map(
                (tag, index) => (
                  <>
                    <CustomTag
                      key={index+"skillNames"}
                      message={tag.name}
                      marginright={'3px'}
                      background="#F0F2F4"
                    />
                    {mandatorySkillNames?.primarySkillNames?.skillNames
                      ?.length !=
                      index + 1 && (
                      <div>
                        <InfoText>
                          {mandatorySkillNames?.primarySkillNames?.type == 'AND'
                            ? '&'
                            : 'OR'}
                        </InfoText>
                      </div>
                    )}
                  </>
                )
              )}
            </FlexWrap>
            {mandatorySkillNames?.mandatorySkillNames?.length ? (
              <SubtitleSmall
                fontsize={FONT.XS}
                padding="4px"
                fontweight={FONT.FW_600}
              >
                <li>Secondary Mandatory Skills</li>
              </SubtitleSmall>
            ) : null}

            <FlexWrap wrap gap="1px" padding="5px 0px 0px 0px">
              {mandatorySkillNames?.mandatorySkillNames?.map((tag, index) => (
                <>
                  <CustomTag
                    key={index+"mandatorySkillNames"}
                    message={tag.name}
                    marginright={'3px'}
                    background="#F0F2F4"
                  />
                  {mandatorySkillNames?.mandatorySkillNames?.length !=
                    index + 1 && (
                    <div>
                      <InfoText>,</InfoText>
                    </div>
                  )}
                </>
              ))}
            </FlexWrap>
            {hasNonEmptySkillSet && mandatorySkillNames?.otherSkillsNames?.length ? (
              <SubtitleSmall
                fontsize={FONT.XS}
                padding="4px"
                fontweight={FONT.FW_600}
              >
                <li>Other Mandatory Skills</li>
              </SubtitleSmall>
            ) : null}
            {hasNonEmptySkillSet && <SkillList>
              {mandatorySkillNames?.otherSkillsNames?.map((skillSet, index) => (
                <>
                  <SubtitleSmall
                    fontsize={FONT.XS}
                    padding="4px"
                    fontweight={FONT.FW_500}
                  >
                    <li>Skill Set {index + 1}</li>
                  </SubtitleSmall>
                  <FlexWrap wrap gap="1px">
                    {skillSet?.skillNames?.map((tag, index2) => (
                      <>
                        <CustomTag
                          key={index+"skillNames"}
                          message={tag.name}
                          marginright={'3px'}
                          background="#F0F2F4"
                        />
                        {skillSet?.skillNames?.length != index2 + 1 && (
                          <div>
                            <InfoText>
                              {skillSet?.type == 'AND' ? '&' : 'OR'}
                            </InfoText>
                          </div>
                        )}
                      </>
                    ))}
                  </FlexWrap>
                </>
              ))}
            </SkillList>}
          </SkillList>
        </div>
        {singleRoleDetails?.optionalSkillsName?.length ? (
          <>
            <PopHeading>Good to Have Skills</PopHeading>
            <Flex wrap>
              {singleRoleDetails?.optionalSkillsName?.map((tag, index) => (
                <CustomTag
                  key={index+"optionalSkillNames"}
                  message={tag.name}
                  marginright={'3px'}
                  background="#F0F2F4"
                />
              ))}
            </Flex>
          </>
        ) : null}
        <PopHeading>Degree & Department</PopHeading>
        {singleRoleDetails?.degreeStreamMap !== undefined &&
          singleRoleDetails?.degreeStreamMap.map((item, index) => (
            <PopSubHeading key={index+"degreeStream"}>
              <li>
                {item?.degree?.shortForm} in {item?.stream?.name}
              </li>
            </PopSubHeading>
          ))}
        <PopHeading>Year of passing</PopHeading>
        {singleRoleDetails?.yearOfPassing !== undefined &&
          singleRoleDetails?.yearOfPassing.map((item, index) => (
            <PopSubHeading key={index+"yearOfPassing"}>
              <li>{item}</li>
            </PopSubHeading>
          ))}
        <PopHeading>Arrears / Backlogs</PopHeading>
        {!singleRoleDetails?.isArrearsAllowed ? (
          <PopSubHeading>No Arrears / Backlogs allowed.</PopSubHeading>
        ) : (
          <PopSubHeading>
            Upto {singleRoleDetails?.arrearCount} Arrears / Backlogs allowed.
          </PopSubHeading>
        )}

        <PopHeading>Scores</PopHeading>
        <PopSubHeading>
          Average mark should be above {singleRoleDetails?.avgScore}% in all
          your exams
        </PopSubHeading>
        <PopSubHeading>
          10th - Above {singleRoleDetails?.tenthScore}%
        </PopSubHeading>
        <PopSubHeading>
          12th or Equivalent - Above {singleRoleDetails?.twelfthScore}%
        </PopSubHeading>
        <PopSubHeading>UG - Above {singleRoleDetails?.UGScore}%</PopSubHeading>
        <PopSubHeading>PG - Above {singleRoleDetails?.PGScore}%</PopSubHeading>
      </>
    )
  }
  const footer = () => {
    const applying = () => {
      onApplyClick(dataSelected)
      setDrawer(false)
    }
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setDrawer(false)
          }}
        />
        <Button.Primary
          htmlType="submit"
          onClick={applying}
          text={'Apply'}
          icon={<CheckIcon />}
        />
      </FooterFlex>
    )
  }
  return (
    
      <StyledDrawer
        width="600px"
        title={'Confirm'}
        placement="right"
        closable={true}
        onClose={() => setDrawer(false)}
        visible={drawer}
        content={content()}
        footer={footer()}
      />
    
  )
}

export default ConfirmDrawer
